import { render, staticRenderFns } from "./Posiciones.vue?vue&type=template&id=4508ab82"
import script from "./Posiciones.vue?vue&type=script&lang=js"
export * from "./Posiciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports